import {
  BeachIconComponent,
  IconsComponent,
  NatureIconComponent,
  CulturalIconComponent,
  FunIconComponent,
  EventsIconComponent,
  HolidayIconComponent,
  BuysIconComponent,
  SportsIconComponent,
  TravelItinerariesIconComponent,
  UnmissableIconComponent,
  ImageIconComponent
} from './icons.component';
import { NgModule } from "@angular/core";

import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        IconsComponent,
        BeachIconComponent,
        NatureIconComponent,
        CulturalIconComponent,
        FunIconComponent,
        EventsIconComponent,
        HolidayIconComponent,
        SportsIconComponent,
        BuysIconComponent,
        TravelItinerariesIconComponent,
        UnmissableIconComponent,
        ImageIconComponent
    ],
    imports: [ CommonModule ],
    exports: [
        IconsComponent,
        ImageIconComponent
    ],
    providers: [],
})
export class IconsModule {}
